/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,no-var,vars-on-top */

import { DESIGNER_EVENTS } from '../../../../../app/constants/designer_events';

(function (angular) {
  angular.module('xplenty-designer').directive('designerControls', [
    '$rootScope',
    '$timeout',
    'notify',
    'dynamicConnectionService',

    function ($rootScope, $timeout, notify, dynamicConnectionService) {
      return {
        templateNamespace: 'html',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-controls.html'),
        replace: true,
        scope: {
          designer: '=',
        },
        link(scope, element, attrs) {
          $timeout(function () {
            scope.history = scope.designer.history;
            scope.package = scope.designer.package;
            element.find('[data-toggle=tooltip]').tooltip({
              animation: false,
            });
            element.find('button').on('click', function () {
              element.find('.tooltip').remove();
              angular.element(this).removeClass('active');
            });
          });

          const $hasSelectionControls = element.find('.has-selection');
          const $selectBadge = element.find('.components-select-badge');
          const $btnSave = element.find('.btn-save');
          const $linkSave = element.find('.link-save');
          const $btnUndo = element.find('.btn-undo');
          const $btnRedo = element.find('.btn-redo');
          const $btnRunJob = element.find('.btn-run-job');
          const $btnValidate = element.find('.btn-validate');
          const $linkVersionValidate = element.find('.link-version-validate');
          const $validationIcon = element.find('.validation-icon');

          $btnUndo.prop('disabled', true);
          $btnRedo.prop('disabled', true);

          $hasSelectionControls.hide();

          scope.addTask = function () {
            if (scope.package.flow_type === 'workflow') {
              $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_MENU, {
                sources: false,
                transformations: false,
                distanations: false,
                workflow: true,
              });
            } else {
              $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_MENU, {
                sources: true,
                transformations: true,
                distanations: true,
                workflow: false,
              });
            }
          };

          scope.editPackage = function () {
            $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_NAME_EDIT, {
              name: scope.designer.package.name,
              description: scope.designer.package.description,
            });
          };

          scope.validate = function () {
            scope.designer.save();

            var event = $rootScope.$on(DESIGNER_EVENTS.PACKAGE_SAVED, function () {
              $rootScope.$broadcast(DESIGNER_EVENTS.VALIDATE);
              event();
            });
          };

          scope.$on(DESIGNER_EVENTS.REVALIDATE, function () {
            scope.validate();
          });

          scope.runJob = function () {
            const run = function () {
              $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_RUN_JOB, {
                id: scope.designer.package.id,
                name: scope.designer.package.name,
              });
            };

            if (scope.packageDataChanged) {
              scope.save(run);
            } else {
              run();
            }
          };

          scope.packageVariables = function () {
            const variablesToEdit = { ...scope.package.variables };
            const variablesToCache = {};

            scope.package.components
              .map((item) => `${item.name}_connection`)
              .forEach((key) => {
                variablesToCache[key] = variablesToEdit[key];
                delete variablesToEdit[key];
              });

            dynamicConnectionService.dynamicConnectionVariables = variablesToCache;
            $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_VARIABLES_EDIT, variablesToEdit);
          };

          scope.save = function (cb) {
            scope.designer.save(cb);
          };

          scope.promoteSourceControlFeature = function () {
            if ($rootScope.is_dpwc) {
              return;
            }

            notify.info(
              'Source Control is disabled',
              "Please contact <a id='support-link'>Support</a> or your Account Manager to activate Source Control feature.",
            );
            $('#support-link').on('click', function () {
              if (angular.isDefined(window.Intercom)) {
                window.Intercom('show');
              }
            });
          };

          $rootScope.$on(DESIGNER_EVENTS.PACKAGE_SELECTION_CHANGE, function (event, totalSelectedComponents) {
            if (totalSelectedComponents === 0) {
              $hasSelectionControls.hide();
              $selectBadge.hide();
            } else {
              $hasSelectionControls.show();
              $selectBadge.text(totalSelectedComponents).show();
            }
          });

          $rootScope.$on(DESIGNER_EVENTS.HISTORY_CHANGE, function (event, history) {
            $btnUndo.prop('disabled', !history.hasUndo);
            $btnRedo.prop('disabled', !history.hasRedo);
            $linkSave.css('pointer-events', !history.packageDataChanged ? 'none' : 'auto');
            scope.packageDataChanged = history.packageDataChanged;
            if (history.packageDataChanged) {
              $btnSave.addClass('btn-success');
              $linkSave.removeClass('disabled');
              $btnRunJob.text('Save & Run job');
            } else {
              $btnSave.removeClass('btn-success');
              $linkSave.addClass('disabled');
              $btnRunJob.text('Run job');
            }
          });

          $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VALIDATION_DISABLED, function (event, disable) {
            $btnValidate.prop('disabled', disable);
          });

          $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VALIDATION_VERSION, function (event, disable) {
            $linkVersionValidate.css('pointer-events', disable ? 'none' : 'auto');
            disable ? $linkVersionValidate.addClass('disabled') : $linkVersionValidate.removeClass('disabled');
          });

          $rootScope.$on(DESIGNER_EVENTS.PACKAGE_VALIDATION_LOADING, function (event, loading) {
            if (loading) {
              $validationIcon.addClass('fa-refresh fa-spin fa-fw');
              $validationIcon.removeClass('fa-check-circle');
              $btnValidate.prop('disabled', true);
            } else {
              $validationIcon.removeClass('fa-refresh fa-spin fa-fw');
              $validationIcon.addClass('fa-check-circle');
              $btnValidate.prop('disabled', false);
            }
          });

          $rootScope.$on(DESIGNER_EVENTS.RESIZE, function (event, size) {
            element.css(size);
          });
        },
      };
    },
  ]);
})(window.angular);
